// 추천지면 로컬스토리지에서 dr_log 가져오는 처리
export const LS_RECOMMEND_PRODUCT_DR_LOG_KEY = 'recommend_product_dr_log';
export const getRecommendProductDrLog = () => {
  const stored_data = localStorage.getItem(LS_RECOMMEND_PRODUCT_DR_LOG_KEY);
  return stored_data ? JSON.parse(stored_data) : {};
};

export const getRecommendProductDrLogByCatalogProductId = (catalog_product_id: string) => {
  const dr_log_map = getRecommendProductDrLog();
  return dr_log_map[catalog_product_id] ?? null;
};

export const setRecommendProductDrLog = (updatedData: Record<string, string>) => {
  localStorage.setItem(LS_RECOMMEND_PRODUCT_DR_LOG_KEY, JSON.stringify(updatedData));
};

export const initRecommendProductDrLog = () => {
  localStorage.removeItem(LS_RECOMMEND_PRODUCT_DR_LOG_KEY);
};
